import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-banner',
  standalone: true,
  imports: [],
  template: `
    <header
      class="bg-gray-900 shadow-lg border-b border-gray-700 w-full relative z-50 text-white"
    >
      <div class="px-4 sm:px-6 lg:px-8">
        <div class="flex items-center gap-x-3 h-16">
          <img
            src="./banner.jpg"
            alt="SNDBX OS"
            class="h-10 w-auto object-contain animate-fade-in"
          />
          <div class="hidden sm:block">
            <h1 class="text-lg font-semibold text-white">SNDBX OS</h1>
          </div>
        </div>
      </div>
    </header>
  `,
  styles: [
    `
      .animate-fade-in {
        opacity: 0;
        animation: fadeIn 0.8s ease-in-out forwards;
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `,
  ],
})
export class AuthBannerComponent {}
